import { topicAttemptStatusRequestKey } from '../utils/topicAttemptRow';
import usePaperAttemptStatuses from './usePaperAttemptStatuses';

/**
 * The attempt status of each section paper (id -> { status, score_correct,
 * score_total, ... }), read from the same endpoint the Practice Topics pages'
 * tables and the Overview's "Practice Topics by tier" rows both rely on, so the two
 * never disagree about what is completed. Empty when signed out, while the
 * request for the signed-in user is on its way, and when it fails.
 */
export default function useSectionPaperStatuses(exam, papers) {
  const statusRequestKey = topicAttemptStatusRequestKey((papers || []).map((p) => p.id));
  return usePaperAttemptStatuses(exam, statusRequestKey).papers;
}
